import { Flex, Spinner, Stack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Footer, Heading, ReactSelect } from '~/components/index';
import { useUsers } from '~/hooks';

export interface Item {
  label: string;
  value: string;
}

export const AccessReports: React.VFC = () => {
  const history = useHistory();
  const [pickerItems, setPickerItems] = useState<Item[]>([]);
  const [selectedItems, setSelectedItems] = useState<Item[]>([]);
  const { isLoading, error } = useUsers(1, '', 9999, {
    staleTime: 0,
    onSuccess: ({ users }) => {
      setPickerItems(
        users.map(user => ({ label: user.login, value: String(user.user_id) })),
      );
    },
  });

  const handleSelectedItemsChange = (items?: Item[]) => {
    if (items) {
      setSelectedItems(items?.length ? [items[items?.length - 1]] : []);
    }
  };

  function handleReport() {
    const user = selectedItems.pop();
    if (user) {
      history.push(
        `/portal/admin/access-reports/${user.value}?login=${user.label}`,
      );
    }
  }

  return (
    <Flex flexDir="column" justify="space-between" h="100%">
      <Flex flexDir="column" px="8" py="4">
        <Heading>Relatórios de Acessos</Heading>
        <Flex py={5} flexDir="column" w={550}>
          <Stack w={400}>
            {isLoading && !pickerItems.length ? (
              <Spinner />
            ) : (
              /* <AutoComplete
                disableCreateItem
                label="Selecione o usuário"
                placeholder="Selecione"
                items={pickerItems}
                selectedItems={selectedItems}
                onSelectedItemsChange={changes =>
                  handleSelectedItemsChange(changes.selectedItems)
                }
              /> */
              <ReactSelect
                isSearchable
                defaultStyle
                options={pickerItems}
                label="Selecione o usuário"
                placeholder="Selecione"
                value={selectedItems}
                onChange={changes =>
                  handleSelectedItemsChange([changes as Item])
                }
              />
            )}
          </Stack>
        </Flex>
      </Flex>
      <Footer>
        <Button disabled={!selectedItems.length} onClick={() => handleReport()}>
          Gerar Relatório
        </Button>
      </Footer>
    </Flex>
  );
};
